module.exports = __webpack_public_path__ + "static/media/1POLICY44.091f2938.jpg";